import { type FC, type SVGProps } from 'react';

import { type ClassNameMap } from '@mui/material';
import { type MicroCopy } from '@vakantiesnl/types';

import { shape5_6, shape6_7, shape8plus, shapeLowerThan_5, shapeNoScore } from './assets/svg';

type Rating = {
	from?: number;
	to?: number;
	label: string;
	shapeIcon: FC<SVGProps<SVGSVGElement> & { title?: string }>;
	className: string;
	rating?: number;
};

export const getRatingConfig = (styles: ClassNameMap, microCopies?: MicroCopy, rating?: number): Rating => {
	const ratingTypes = [
		{
			from: 9,
			to: 10,
			label: microCopies ? microCopies['score.label.phenomenal'] : 'score.label.phenomenal',
			shapeIcon: shape8plus,
			className: styles.darkGreen,
		},
		{
			from: 8,
			to: 8.9,
			label: microCopies ? microCopies['score.label.fantastic'] : 'score.label.fantastic',
			shapeIcon: shape8plus,
			className: styles.darkGreen,
		},
		{
			from: 7,
			to: 7.9,
			label: microCopies ? microCopies['score.label.good'] : 'score.label.good',
			shapeIcon: shape6_7,
			className: styles.green,
		},
		{
			from: 5.5,
			to: 6.9,
			label: microCopies ? microCopies['score.label.enough'] : 'score.label.enough',
			shapeIcon: shape5_6,
			className: styles.yellow,
		},
		{
			from: 4.5,
			to: 5.4,
			label: microCopies ? microCopies['score.label.mediocre'] : 'score.label.mediocre',
			shapeIcon: shapeLowerThan_5,
			className: styles.red,
		},
		{
			from: 0,
			to: 4.4,
			label: microCopies ? microCopies['score.label.inadequate'] : 'score.label.inadequate',
			shapeIcon: shapeLowerThan_5,
			className: styles.red,
		},
	];

	const defaultResult = {
		label: microCopies ? microCopies['score.label.notAvailable'] : 'score.label.notAvailable',
		className: styles.gray,
		shapeIcon: shapeNoScore,
		rating: 0,
	};

	if (!rating) {
		return defaultResult;
	}

	const formattedRating = Number(rating.toFixed(1));

	const ratingConfigResult = ratingTypes.find((v) => formattedRating >= v.from && formattedRating <= v.to);

	if (ratingConfigResult) {
		const { label, className, shapeIcon } = ratingConfigResult;
		return { label, className, shapeIcon, rating: formattedRating };
	}

	return defaultResult;
};
